const wordMap = {
  "中文字段 Chinese": "英文字段 English",
  "安徽审计厅": "Anhui Provincial Audit Department ",
  "安徽省统计局": "Anhui Provincial Bureau of Statistics ",
  "安康统计信息网": "Ankang Statistical Information Network ",
  "安庆市统计局": "Anqing Municipal Bureau of Statistics ",
  "安顺市统计局": "Anshun Municipal Bureau of Statistics",
  "鞍山银行": "Bank of Anshan",
  "澳新银行": "Australia and New Zealand Banking Group ",
  "蚌埠市统计局": "Bengbu Municipal Bureau of Statistics  ",
  "包商银行": "Baoshang Bank",
  "宝鸡市统计局": "Baoji Municipal Bureau of Statistics  ",
  "宝山统计信息网": "Baoshan Statistical Information Network  ",
  "保定市统计局": "Baoding Municipal Bureau of Statistics   ",
  "保监会": "China Insurance Regulatory Commission",
  "北京农商银行": "Beijing Rural Commercial Bank ",
  "北京市审计局": "Beijing Municipal Audit Bureau",
  "北京市统计局": "Beijing Municipal Bureau of Statistics",
  "北京银行": "Bank of Beijing",
  "本溪市统计局": "Benxi Municipal Bureau of Statistics ",
  "毕节市统计局": "Bijie Municipal Bureau of Statistics ",
  "渤海银行": "China Bohai Bank",
  "财政部": "Ministry of Finance",
  "沧州银行": "Bank of Cangzhou",
  "常熟农村商业银行": "Changshu Rural Commercial Bank",
  "常州市统计局": "Changzhou Municipal Bureau of Statistics  ",
  "成都农商银行": "Chengdu Rural Commercial Bank ",
  "成都市统计局": "Chengdu Bureau of Statistics ",
  "成都银行": "Bank of Chengdu",
  "承德市统计局": "Chengde Municipal Bureau of Statistics   ",
  "赤峰市统计局": "Chifeng Municipal Bureau of Statistics    ",
  "崇明统计信息网": "Chongming Statistical Information Network ",
  "滁州市统计局": "Chuzhou Municipal Bureau of Statistics",
  "大华银行": "United Overseas Bank",
  "大理白族自治州统计局": "Dali Bai Autonomous Prefecture Bureau of Statistics ",
  "大连商品交易所": "Dalian Commodity Exchange ",
  "大连市统计局": "Dalian Municipal Bureau of Statistics ",
  "大连银行": "Bank of Dalian",
  "大庆市商业银行": "Daqing Commercial Bank ",
  "丹东银行": "Bank of Dandong ",
  "德阳市统计局": "Deyang Municipal Bureau of Statistics  ",
  "德阳银行": "Bank of Deyang",
  "德银中国": "Deutsche Bank (China) ",
  "德州银行": "Dezhou Bank",
  "东方证券": "Orient Securities ",
  "东莞农村商业银行": "Dongguan Rural Commercial Bank",
  "东莞银行": "Bank of Dongguan",
  "东吴证券": "Soochow Securities ",
  "东兴证券": "Dongxing Securities ",
  "东亚银行": "Bank of East Asia",
  "东营市商业银行": "Dongying Commercial Bank ",
  "鄂尔多斯市统计局": "Ordos Municipal Bureau of Statistics ",
  "法兴银行": "Societe Generale ",
  "方正证券": "Founder Securities ",
  "奉贤统计信息网": "Fengxian Statistical Information Network ",
  "福建海峡银行": "Fujian Haixia Bank ",
  "福建审计厅": "Fujian Provincial Audit Department",
  "福建省统计局": "Fujian Provincial Bureau of Statistics ",
  "福州市统计局": "Fuzhou Municipal Bureau of Statistics",
  "阜新市统计局": "Fuxin Municipal Bureau of Statistics ",
  "阜新银行": "Bank of Fuxin ",
  "复旦大学": "Fudan University",
  "富滇银行": "Fudian Bank",
  "甘肃审计厅": "Gansu Provincial Audit Department",
  "甘肃省统计局": "Gansu Provincial Bureau of Statistics  ",
  "赶集网": "ganji.com ",
  "赣州市统计局": "Ganzhou Municipal Bureau of Statistics",
  "赣州银行": "Bank of Ganzhou",
  "工商行政管理总局": "General Administration for Industry and Commerce ",
  "工商银行": "Industrial and Commercial Bank of China",
  "固原市统计局": "Guyuan Municipal Bureau of Statistics ",
  "光大证券": "Everbright Securities ",
  "广东审计厅": "Guangdong Provincial Audit Department",
  "广东省统计局": "Guangdong Provincial Bureau of Statistics  ",
  "广发银行": "China Guangfa Bank",
  "广发证券": "GF Securities ",
  "广交会": "Canton Fair",
  "广西北部湾银行": "Guangxi Beibu Gulf Bank ",
  "广西审计厅": "Guangxi Provincial Audit Department",
  "广西省统计局": "Guangxi Provincial Bureau of Statistics",
  "广西统计局": "Guangxi Provincial Bureau of Statistics",
  "广州农村商业银行": "Guangzhou Rural Commercial Bank",
  "广州市统计局": "Guangzhou Municipal Bureau of Statistics",
  "广州统计信息网": "Guangzhou Statistical Information Network ",
  "广州银行": "Bank of Guangzhou ",
  "贵港市统计局": "Guigang Municipal Bureau of Statistics",
  "贵阳市统计局": "Guiyang Municipal Bureau of Statistics",
  "贵阳银行": "Bank of Guiyang",
  "贵州审计厅": "Guizhou Provincial Audit Department ",
  "贵州省统计局": "Guizhou Provincial Bureau of Statistics",
  "桂林市商业银行": "Guilin Commercial Bank ",
  "国海证券": "Sealand Securities ",
  "国际货币基金组织": "International Monetary Fund",
  "国际清算银行": "Bank for International Settlements ",
  "国家版权局": "National Copyright Administration ",
  "国家海洋局": "State Oceanic Administration ",
  "国家能源局": "National Energy Administration ",
  "国家审计署": "National Audit Office ",
  "国家统计局": "National Bureau of Statistics ",
  "国家外汇管理局": "State Administration of Foreign Exchange ",
  "国家卫生和计划生育委员会": "National Health and Family Planning Commission ",
  "国家知识产权局": "National Intellectual Property Administration",
  "国金证券": "Sinolink Securities ",
  "国泰君安": "Guotai Junan Securities ",
  "国统局": "National Bureau of Statistics  ",
  "国土资源部": "Ministry of Land and Resources ",
  "国务院": "State Council",
  "国信证券": "Guosen Securities",
  "国元证券": "Guoyuan Securities ",
  "国资委": "State-owned Assets Supervision and Administration Commission ",
  "哈尔滨市统计局": "Harbin Municipal Bureau of Statistics ",
  "哈尔滨银行": "Harbin Bank ",
  "海关总署": "General Administration of Customs",
  "海口市统计局": "Haikou Municipal Bureau of Statistics  ",
  "海口统计信息网": "Haikou Statistical Information Network ",
  "海南审计厅": "Hainan Provincial Audit Department ",
  "海南省统计局": "Hainan Provincial Bureau of Statistics  ",
  "海通证券": "Haitong Securities ",
  "邯郸市商业银行": "Handan Commercial Bank ",
  "邯郸市统计局": "Handan Municipal Bureau of Statistics   ",
  "汉口银行": "Hankou Bank ",
  "汉中统计信息网": "Hanzhong Statistical Information Network ",
  "杭州市统计局": "Hangzhou Municipal Bureau of Statistics",
  "杭州银行": "Bank of Hangzhou",
  "合肥科技农村商业银行": "Hefei Science & Technology Rural Commercial Bank",
  "合肥市统计局": "Hefei Municipal Bureau of Statistics ",
  "合肥统计局": "Hefei Municipal Bureau of Statistics ",
  "河北审计厅": "Hebei Provincial Audit Department",
  "河北省统计局": "Hebei Provincial Bureau of Statistics ",
  "河北银行": "Bank of Hebei",
  "河南审计厅": "Henan Provincial Audit Department",
  "河南省统计局": "Henan Provincial Bureau of Statistics",
  "黑龙江审计厅": "Heilongjiang Provincial Audit Department ",
  "黑龙江省统计局": "Heilongjiang Provincial Bureau of Statistics",
  "恒丰银行": "Evergrowing Bank",
  "恒生银行": "Hang Seng Bank",
  "衡水市统计局": "Hengshui Municipal Bureau of Statistics  ",
  "呼和浩特市统计局": "Hohhot Municipal Bureau of Statistics   ",
  "湖北审计厅": "Hubei Provincial Audit Department",
  "湖北省统计局": "Hubei Provincial Bureau of Statistics",
  "湖北银行": "Bank of Hubei ",
  "湖南省统计局": "Hunan Provincial Bureau of Statistics",
  "湖州市统计局": "Huzhou Municipal Bureau of Statistics",
  "花旗银行": "Citibank ",
  "华侨银行": "Oversea-Chinese Banking Corp ",
  "华融湘江银行": "Huarong Xiangjiang Bank ",
  "华泰证券": "Huatai Securities ",
  "华夏新供给经济学研": "China Academy of New Supply-side Economics ",
  "华夏银行": "Hua Xia Bank ",
  "华一银行": "First Sino Bank ",
  "淮安市统计局": "Huai'an Municipal Bureau of Statistics  ",
  "黄河农村商业银行": "Yellow River Rural Commercial Bank",
  "徽商银行": "Huishang Bank",
  "汇丰银行": "HSBC",
  "汇丰银行/财新网": "HSBC/caixin.com ",
  "惠城区农村信用社": "Huicheng Rural Credit Cooperative ",
  "吉安市统计局": "Ji'an Municipal Bureau of Statistics",
  "吉林九台农村商业银行": "Jilin Jiutai Rural Commercial Bank",
  "吉林审计厅": "Jilin Provincial Audit Department",
  "吉林省统计局": "Jilin Provincial Bureau of Statistics ",
  "吉林银行": "Bank of Jilin ",
  "济南市统计局": "Ji'nan Municipal Bureau of Statistics ",
  "嘉定统计信息网": "Jiading Statistical Information Network ",
  "嘉兴市统计局": "Jiading Municipal Bureau of Statistics  ",
  "嘉兴银行": "Bank of Jiaxing ",
  "建设银行": "China Construction Bank",
  "江南农村商业银行": "Jiangnan Rural Commercial Bank",
  "江苏如皋农村商业银行": "Jiangsu Rugao Rural Commercial Bank ",
  "江苏审计厅": "Jiangsu Provincial Audit Department ",
  "江苏省省统计局": "Jiangsu Provincial Bureau of Statistics ",
  "江苏省统计局": "Jiangsu Provincial Bureau of Statistics",
  "江苏新沂农村商业银行": "Jiangsu Xinyi Rural Commercial Bank",
  "江苏银行": "Bank of Jiangsu ",
  "江西审计厅": "Jiangxi Provincial Audit Department",
  "江西省统计局": "Jiangxi Provincial Bureau of Statistics",
  "交通银行": "Bank of Communications",
  "交通运输部": "Ministry of Transport",
  "教育部": "Ministry of Education",
  "教育涉外监管信息网": "www.jsj.edu.cn",
  "教育网": "China Educational Information Platform ",
  "金华市统计局": "Jinhua Municipal Bureau of Statistics ",
  "金华银行": "Bank of Jinhua ",
  "金山统计信息网": "Jinshan Statistical Information Network",
  "锦州市统计局": "Jinzhou Municipal Bureau of Statistics",
  "锦州银行": "Bank of Jinzhou",
  "晋城市统计局": "Jincheng Municipal Bureau of Statistics ",
  "晋城银行": "Jincheng Bank",
  "晋商银行": "Jinshang Bank",
  "晋中市商业银行": "Jinzhong Commercial Bank ",
  "晋中市统计局": "Jinzhong Municipal Bureau of Statistics",
  "九江银行": "Bank of Jiujiang ",
  "昆明市统计局": "Kunming Municipal Bureau of Statistics ",
  "昆山农村商业银行": "Kunshan Rural Commercial Bank",
  "拉萨统计局": "Lhasa Municipal Bureau of Statistics  ",
  "莱商银行": "Laishang Bank",
  "兰州市统计局": "Lanzhou Municipal Bureau of Statistics",
  "兰州统计局": "Lanzhou Municipal Bureau of Statistics",
  "兰州银行": "Bank Of Lanzhou",
  "廊坊银行": "Bank of Langfang",
  "乐山市商业银行": "Leshan City Commercial Bank",
  "丽江市统计局": "Lijiang Municipal Bureau of Statistics ",
  "丽水市统计局": "Lishui Municipal Bureau of Statistics",
  "联合国开发计划署": "UNDP ",
  "辽宁审计厅": "Liaoning Provincial Audit Department",
  "辽宁省统计局": "Liaoning Provincial Bureau of Statistics ",
  "临汾市统计局": "Linfen Municipal Bureau of Statistics ",
  "临商银行": "Linshang Bank",
  "柳州市商业银行": "Liuzhou City Commercial Bank",
  "六盘水市统计局": "Liupanshui Municipal Bureau of Statistics  ",
  "龙江银行": "Bank of Longjiang ",
  "泸州市统计局": "Luzhou Municipal Bureau of Statistics",
  "洛阳银行": "Bank of Luoyang",
  "吕梁市统计局": "Lvliang Municipal Bureau of Statistics ",
  "绵阳市统计局": "Mianyang Municipal Bureau of Statistics",
  "民政部": "Ministry of Civil Affairs",
  "闵行统计信息网": "Minhang Statistical Information Network ",
  "牡丹江市统计局": "Mudanjiang Municipal Bureau of Statistics  ",
  "南昌市统计局": "Nanchang Municipal Bureau of Statistics ",
  "南昌银行": "Bank of Nanchang ",
  "南充市商业银行": "Nanchong City Commercial Bank",
  "南京市统计局": "Nanjing Municipal Bureau of Statistics",
  "南京统计局": "Nanjing Municipal Bureau of Statistics",
  "南京银行": "Bank of Nanjing ",
  "南宁市统计局": "Nanning Municipal Bureau of Statistics",
  "南通市统计局": "Nantong Municipal Bureau of Statistics",
  "南洋商业银行": "Nanyang Commercial Bank ",
  "内蒙古审计厅": "Audit Department of Inner Mongolia Autonomous Region ",
  "内蒙古统计局": "Bureau of Statistics of Inner Mongolia Autonomous Region ",
  "内蒙古自治区统计局": "Bureau of Statistics of Inner Mongolia Autonomous Region ",
  "宁波市统计局": "Ningbo Municipal Bureau of Statistics ",
  "宁波银行": "Bank of Ningbo ",
  "宁夏审计厅": "Audit Department of Ningxia Hui Autonomous Region ",
  "宁夏统计局": "Bureau of Statistics of Ningxia Hui Autonomous Region",
  "宁夏银行": "Bank of Ningxia",
  "农业部": "Ministry of Agriculture",
  "农业银行": "Agricultural Bank of China ",
  "攀枝花市统计局": "Panzhihua Municipal Bureau of Statistics ",
  "平安银行": "Ping An Bank ",
  "平安银行：定期存款利率：1年（零存整取、整存零取、存本取息）": "Ping An Bank: Time Deposit Rate: 1 Year (Deposit in Installments While Withdraw in Lump Sum, Deposit in Lump Sum and Withdraw in Installments, Deposit in Lump Sum and Withdraw the Interest Periodically)",
  "平安银行：定期存款利率：1年（整存整取）": "Ping An Bank: Time Deposit Rate: 1 Year (Deposit and Withdraw in Lump Sum) ",
  "平安银行：定期存款利率：2年（整存整取）": "Ping An Bank: Time Deposit Rate: 2 Years (Deposit and Withdraw in Lump Sum)",
  "平安银行：定期存款利率：3个月": "Ping An Bank: Time Deposit Rate: 3 Years",
  "平安银行：定期存款利率：3年（零存整取、整存零取、存本取息）": "Ping An Bank: Time Deposit Rate: 3 Years (Deposit in Installments While Withdraw in Lump Sum, Deposit in Lump Sum and Withdraw in Installments, Deposit in Lump Sum and Withdraw the Interest Periodically)",
  "平安银行：定期存款利率：3年（整存整取）": "Ping An Bank: Time Deposit Rate: 3 Years (Deposit and Withdraw in Lump Sum)",
  "平安银行：定期存款利率：5年（零存整取、整存零取、存本取息）": "Ping An Bank: Time Deposit Rate: 5 Years (Deposit in Installments While Withdraw in Lump Sum, Deposit in Lump Sum and Withdraw in Installments, Deposit in Lump Sum and Withdraw the Interest Periodically)",
  "平安银行：定期存款利率：5年（整存整取）": "Ping An Bank: Time Deposit Rate: 5 Years (Deposit and Withdraw in Lump Sum)",
  "平安银行：定期存款利率：6个月": "Ping An Bank: Time Deposit Rate: 6 Months",
  "平安银行：活期存款利率": "Ping An Bank: Demand Deposit Rate",
  "平安银行：通知存款利率：1天": "Ping An Bank: Rate of Call: 1 Day",
  "平安银行：通知存款利率：7天": "Ping An Bank: Rate of Call: 7 Days",
  "平安银行：协定存款利率": "Ping An Bank: Agreement Deposit Rate",
  "浦发银行": "Shanghai Pudong Development Bank",
  "普洱市统计局": "Pu'er Municipal Bureau of Statistics",
  "齐鲁银行": "Qilu Bank",
  "齐齐哈尔统计信息网": "Qiqihar Statistical Information Network ",
  "齐商银行": "Qishang Bank",
  "前瞻网": "qianzhan.com",
  "秦皇岛市统计局": "Qinhuangdao Municipal Bureau of Statistics ",
  "青岛市商业银行": "Qingdao City Commercial Bank ",
  "青岛市统计局": "Qingdao Municipal Bureau of Statistics  ",
  "青海审计厅": "Qinghai Provincial Audit Department ",
  "青海省统计局": "Qinghai Provincial Bureau of Statistics ",
  "青浦区统计局": "Bureau of Statistics of Qingpu District ",
  "青浦统计信息网": "Qingpu Statistical Information Network ",
  "衢州市统计局": "Hengzhou Municipal Bureau of Statistics",
  "曲靖市统计局": "Qujing Municipal Bureau of Statistics ",
  "全国社会保障基金理事会": "National Council for Social Security Fund ",
  "泉州银行": "Bank of Quanzhou",
  "人力资源和社会保障部": "Ministry of Human Resources and Social Security",
  "日照银行": "Bank of Rizhao",
  "瑞丰银行": "Bank of Ruifeng",
  "三亚统计信息网": "Sanya Statistical Information Network ",
  "厦门市统计局": "Xiamen Municipal Bureau of Statistics  ",
  "厦门银行": "Xiamen Bank ",
  "山东审计厅": "Shandong Provincial Audit Department",
  "山东省统计局": "Shandong Provincial Bureau of Statistics",
  "山西审计厅": "Shanxi Provincial Audit Department",
  "山西省统计局": "Shanxi Provincial Bureau of Statistics",
  "山西证券": "Shanxi Securities ",
  "陕西审计厅": "Shaanxi Provincial Audit Department",
  "陕西省统计局": "Shaanxi Provincial Bureau of Statistics",
  "商洛统计信息网": "Shangluo Statistical Information Network ",
  "商务部": "Ministry of Commerce",
  "上海财经大学": "Shanghai University of Finance and Economics ",
  "上海农村商业银行": "Shanghai Rural Commercial Bank",
  "上海浦东发展银行": "Shanghai Pudong Development Bank",
  "上海期货交易所": "Shanghai Futures Exchange ",
  "上海清算所": "Shanghai Clearing House ",
  "上海市口岸服务办公室": "Shanghai Municipal Office for Port Services",
  "上海市审计局": "Shanghai Municipal Audit Bureau",
  "上海市统计局": "Shanghai Municipal Bureau of Statistics",
  "上海银行": "Bank of Shanghai",
  "上海证券交易所": "Shanghai Stock Exchange ",
  "上交所": "Shanghai Stock Exchange",
  "上饶银行": "Bank of Shangrao ",
  "绍兴银行": "Bank of Shaoxing ",
  "深交所": "Shenzhen Stock Exchange",
  "深圳农村商业银行": "Shenzhen Rural Commercial Bank",
  "深圳市统计局": "Shenzhen Municipal Bureau of Statistics ",
  "深圳证券交易所": "Shenzhen Stock Exchange ",
  "沈阳市统计局": "Shenyang Municipal Bureau of Statistics",
  "省统计局": "Provincial Bureau of Statistics",
  "盛京银行": "Shengjing Bank",
  "石家庄市统计局": "Shijiazhuang Municipal Bureau of Statistics ",
  "石嘴山统计局": "Shizuishan Municipal Bureau of Statistics  ",
  "水利部": "Ministry of Water Resources ",
  "顺德农商银行": "Shunde Rural Commercial Bank ",
  "朔州市统计局": "Shuozhou Municipal Bureau of Statistics",
  "四川审计厅": "Sichuan Provincial Audit Department ",
  "四川省统计局": "Sichuan Provincial Bureau of Statistics ",
  "松江统计信息网": "Songjiang Statistical Information Network ",
  "苏州市统计局": "Suzhou Municipal Bureau of Statistics",
  "苏州银行": "Bank of Suzhou ",
  "台州市商业银行": "Taizhou City Commercial Bank",
  "台州市统计局": "Taizhou Municipal Bureau of Statistics",
  "太平洋证券": "Pacific Securities ",
  "太原市统计局": "Taiyuan Municipal Bureau of Statistics",
  "泰安市商业银行": "Tai'an City Commercial Bank",
  "泰州市统计局": "Tai'an Municipal Bureau of Statistics",
  "天津滨海农村商业银行": "Tianjin Binhai Rural Commercial Bank ",
  "天津农商银行": "Tianjin Rural Commercial Bank  ",
  "天津市审计局": "Tianjin Municipal Audit Bureau ",
  "天津市统计局": "Tianjin Municipal Bureau of Statistics",
  "天津银行": "Bank of Tianjin ",
  "天气后报网": "tianqihoubao.com ",
  "同信证券": "TongXin Securities",
  "铜川市统计局": "Tongchuan Municipal Bureau of Statistics ",
  "铜仁市统计局": "Tongren Municipal Bureau of Statistics",
  "外管局": "State Administration of Foreign Exchange ",
  "威海市商业银行": "Weihai City Commercial Bank",
  "潍坊银行": "Bank of Weifang",
  "渭南市统计局": "Weinan Municipal Bureau of Statistics",
  "温州民间借贷服务网": "wzmjjddj.com",
  "温州市商业银行": "Wenzhou City Commercial Bank",
  "温州市统计局": "Wenzhou Municipal Bureau of Statistics",
  "文化部": "Ministry of Culture",
  "乌海市统计局": "Weihai Municipal Bureau of Statistics",
  "乌鲁木齐市商业银行": "Urumqi City Commercial Bank ",
  "乌鲁木齐市统计局": "Urumqi Municipal Bureau of Statistics",
  "无锡市统计局": "Wuxi Municipal Bureau of Statistics ",
  "吴江农村商业银行": "Wujiang Rural Commercial Bank",
  "武汉市统计局": "Wuhan Municipal Bureau of Statistics ",
  "武汉统计信息网": "Wuhan Statistical Information Network ",
  "西安市商业银行": "Xi'an City Commercial Bank",
  "西安市统计局": "Xi'an Municipal Bureau of Statistics",
  "西安统计信息网": "Xi'an Statistical Information Network  ",
  "西本新干线": "http://m.96369.net/ ",
  "西藏统计局": "Tibet Autonomous Region Bureau of Statistics ",
  "西南证券": "Southwest Securities ",
  "西宁市统计局": "Xining Municipal Bureau of Statistics",
  "咸阳统计信息网": "Xianyang Statistical Information Network ",
  "忻州市统计局": "Xinzhou Municipal Bureau of Statistics",
  "新会农村商业银行": "Xinhui Rural Commercial Bank",
  "新疆审计厅": "Xinjiang Autonomous Region Audit Department ",
  "新疆统计局": "Xinjiang Autonomous Region Bureau of Statistics ",
  "新疆自治区统计局": "Xinjiang Autonomous Region Bureau of Statistics ",
  "邢台市统计局": "Xingtai Municipal Bureau of Statistics ",
  "兴安盟统计局": "Hinggan League Bureau of Statistics   ",
  "兴业银行": "Industrial Bank",
  "兴业证券": "Industrial Securities ",
  "徐州统计局": "Xuzhou Municipal Bureau of Statistics",
  "烟台银行": "Yantai Bank",
  "延安统计信息网": "Yan'an Statistical Information Network",
  "扬州农村商业银行": "Yangzhou Rural Commercial Bank",
  "阳泉市统计局": "Yangquan Municipal Bureau of Statistics ",
  "杨凌示范区统计局": "Bureau of Statistics of Yangling Demonstration Zone ",
  "宜春市统计局": "Yichun Municipal Bureau of Statistics  ",
  "银川市统计局": "Yinchuan Municipal Bureau of Statistics",
  "银监会": "China Banking Regulatory Commission ",
  "鄞州银行": "Bank of  Yinzhou",
  "营口银行": "Bank of Yingkou ",
  "永亨银行（中国）": "Wing Hang Bank (China) ",
  "余杭农村合作银行": "Yuhang Rural Cooperative Bank ",
  "榆林市统计局": "Yulin Municipal Bureau of Statistics  ",
  "玉溪市统计局": "Yuxi Municipal Bureau of Statistics    ",
  "云南审计厅": "Yunnan Provincial Audit Department",
  "云南省统计局": "Yunnan Provincial Bureau of Statistics",
  "运城市统计局": "Yuncheng Municipal Bureau of Statistics",
  "渣打银行": "Standard Chartered Bank",
  "湛江市商业银行": "Zhanjiang City Commercial Bank ",
  "张家港农村商业银行": "Zhangjiagang Rural Commercial Bank",
  "张家口市统计局": "Zhangjiakou Municipal Bureau of Statistics ",
  "长安银行": "Chang'an Bank",
  "长春市统计局": "Changchun Municipal Bureau of Statistics",
  "长春统计局": "Changchun Municipal Bureau of Statistics",
  "长江商学院": "Cheung Kong Graduate School of Business",
  "长江证券": "Changjiang Securities ",
  "长沙市统计局": "Changsha Municipal Bureau of Statistics",
  "长沙统计信息网": "Changsha Statistical Information Network ",
  "长沙银行": "Bank of Changsha",
  "长治市统计局": "Changzhi Municipal Bureau of Statistics",
  "招商银行": "China Merchants Bank",
  "招商证券": "Merchants Securities ",
  "昭通市统计局": "Zhaotong Municipal Bureau of Statistics",
  "浙江稠州商业银行": "Zhejiang Chouzhou Commercial Bank",
  "浙江民泰商业银行": "Zhejiang Mintai Commercial Bank ",
  "浙江审计厅": "Zhejiang Provincial Audit Department ",
  "浙江省统计局": "Zhejiang Provincial Bureau of Statistics ",
  "浙江泰隆商业银行": "Zhejiang Tailong Commercial Bank ",
  "浙商银行": "Zheshang Bank",
  "镇江市统计局": "Zhenjiang Municipal Bureau of Statistics",
  "证监会": "China Securities Regulatory Commission ",
  "郑州商品交易所": "Zhengzhou Commodity Exchange ",
  "郑州商品期货交易所": "Zhengzhou Commodity Futures Exchange",
  "郑州市统计局": "Zhengzhou Municipal Bureau of Statistics",
  "郑州银行": "Bank Of Zhengzhou",
  "中德住房储蓄银行": "Sino-German Bausparkasse ",
  "中共中央纪律检查委员会": "Central Commission for Discipline Inspection of the Communist Party of China ",
  "中国产业信息": "https://www.chyxx.com/",
  "中国城市统计年鉴": "China Urban Statistical Yearbooks",
  "中国工商银行": "Industrial and Commercial Bank of China",
  "中国光大银行": "China Everbright Bank ",
  "中国环境保护数据库": "China Environmental Protection Database ",
  "中国建设银行": "China Construction Bank",
  "中国金融期货交易所": "China Financial Futures Exchange ",
  "中国经济景气月报": "China Monthly Economic Indicators ",
  "中国民生银行": "China Minsheng Bank",
  "中国农业银行": "Agricultural Bank of China",
  "中国票据网": "zgpjw.com ",
  "中国期货市场监控中心": "China Futures Market Monitoring Center ",
  "中国企业家调查系统": "China Entrepreneur Survey System ",
  "中国人民银行": "People's Bank of China",
  "中国社会科学院": "Chinese Academy of Social Sciences",
  "中国统计年鉴": "Statistical Yearbooks of China",
  "中国外汇交易中心": "China Foreign Exchange Trade System  ",
  "中国物流与采购联合会": "China Federation of Logistics and Purchasing ",
  "中国银行": "Bank of China",
  "中国银行(香港)": "Bank of China (Hong Kong) ",
  "中国银行间市场交易商协会": "National Association of Financial Market Institutional Investors ",
  "中国银行业监督管理委员会": "China Banking Regulatory Commission ",
  "中国银联": "China Unionpay ",
  "中国邮政储蓄银行": "Postal Savings Bank of China",
  "中国有色金属工业协会": "China Nonferrous Metals Industry Association ",
  "中国债券信息网": "chinabond.com",
  "中国证券登记结算公司": "China Securities Depository and Clearing Corporation Limited ",
  "中国证券监督委员会": "China Securities Regulatory Commission ",
  "中国证券投资者保护网": "China Securities Investor Protection Fund Corporation ",
  "中国证券业协会": "Securities Association of China ",
  "中国中小企业协会": "China Association of Small and Medium Enterprises",
  "中经产业景气指数": "China Economy Industry Prosperity Index",
  "中山市农村信用合作社": "Zhongshan Rural Credit Cooperative",
  "中信银行": "China CITIC Bank",
  "中信证券": "CITIC Securities",
  "中证指数有限公司": "China  Securities Index Co,. Ltd. ",
  "重庆三峡银行": "Chongqing Three Gorges Bank ",
  "重庆市审计局": "Chongqing Municipal Audit Bureau ",
  "重庆市统计局": "Chongqing Municipal Bureau of Statistics",
  "重庆统计信息网": "Chongqing Statistical Information Network ",
  "舟山市统计局": "Zhoushan Municipal Bureau of Statistics ",
  "珠海华润银行": "Zhuhai Huarun Bank ",
  "最高人民法院": "Supreme People's Court ",
  "遵义市统计局": "Zunyi Municipal Bureau of Statistics  ",
  "Choice数据": "Choice Data"
}

export default wordMap
